import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid mb-3"
}
const _hoisted_2 = {
  key: 1,
  class: "grid mb-3"
}
const _hoisted_3 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FeedCreativeCard = _resolveComponent("FeedCreativeCard")!
  const _component_PrimeVuePaginator = _resolveComponent("PrimeVuePaginator")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueSidebar = _resolveComponent("PrimeVueSidebar")!
  const _component_PrimeVueScrollTop = _resolveComponent("PrimeVueScrollTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: "Feeds Creatives",
      "show-refresh-button": "",
      "refresh-button-handler": _ctx.fetchFeedsCreatives,
      "refresh-button-loading": _ctx.feedsCreativesLoading,
      "show-filters-button": "",
      "show-filters": _ctx.feedsCreativesFiltersShow,
      "onUpdate:showFilters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feedsCreativesFiltersShow) = $event))
    }, null, 8, ["refresh-button-handler", "refresh-button-loading", "show-filters"]),
    (_ctx.feedsCreativesLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
            return _createElementVNode("div", {
              class: "col-12 sm:col-6 md:col-3 lg:col-2",
              key: i
            }, [
              _createVNode(_component_PrimeVueSkeleton, {
                class: "border-round-lg",
                width: "100%",
                height: "450px"
              })
            ])
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedsCreatives.data, (creative) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 sm:col-6 md:col-3 lg:col-2",
              key: creative.id
            }, [
              _createVNode(_component_FeedCreativeCard, { creative: creative }, null, 8, ["creative"])
            ]))
          }), 128))
        ])),
    _createVNode(_component_PrimeVuePaginator, _mergeProps({
      "total-records": _ctx.feedsCreatives.meta.total,
      rows: _ctx.ENTRIES_PER_PAGE
    }, _toHandlers(_ctx.paginatorEvents)), null, 16, ["total-records", "rows"]),
    _createVNode(_component_PrimeVueSidebar, {
      visible: _ctx.feedsCreativesFiltersShow,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.feedsCreativesFiltersShow) = $event)),
      position: "right",
      dismissable: ""
    }, {
      default: _withCtx(() => [
        (_ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feedsCreativesFilters.project_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feedsCreativesFilters.project_id) = $event)),
                modelModifiers: { number: true },
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                "show-clear": "",
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name"
              }, null, 8, ["modelValue", "label", "loading", "options"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FieldDropdownAutoComplete, {
            modelValue: _ctx.feedsCreativesFilters.feed_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.feedsCreativesFilters.feed_id) = $event)),
            modelModifiers: { number: true },
            name: "feed_id",
            label: _ctx.$t('feed'),
            "show-clear": "",
            "api-url": "/api/v3/feeds/options",
            "api-params": _ctx.feedsParams,
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "api-params"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.feedsCreativesFilters.country_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.feedsCreativesFilters.country_id) = $event)),
            label: _ctx.$t('country'),
            loading: _ctx.countriesLoading,
            "show-clear": "",
            filter: "",
            options: _ctx.countries.data,
            "option-value": "id",
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "loading", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FieldText, {
            modelValue: _ctx.feedsCreativesFilters.keyword,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.feedsCreativesFilters.keyword) = $event)),
            modelModifiers: { trim: true },
            label: "Keyword"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FieldBidCPC, {
            modelValue: _ctx.feedsCreativesFilters.min_bid,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.feedsCreativesFilters.min_bid) = $event)),
            modelModifiers: { number: true },
            name: "min_bid",
            label: _ctx.$t('min_bid')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createVNode(_component_PrimeVueButton, {
          class: "mt-3 w-full",
          label: _ctx.$t('apply'),
          loading: _ctx.feedsCreativesLoading,
          onClick: _ctx.fetchFeedsCreatives
        }, null, 8, ["label", "loading", "onClick"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PrimeVueScrollTop)
  ], 64))
}